import { enableModulesPaths } from "constants/modules";
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { checkIsMemberDirectoryEnabled, checkIsModuleEnabled, getMemberSettings } from "utils/accessLocalStorageData";


const EnabledMemberRoute = ({ component: Component, enableModuleKey, page, ...rest }) => {
  const isModuleEnabled = checkIsModuleEnabled(enableModuleKey);
  const memberSettings = getMemberSettings();

  const handleRedirect = () => {
    for (const [key, value] of Object.entries(memberSettings)) {
      if (value) return enableModulesPaths[key] || "/home"
    }
    if (checkIsMemberDirectoryEnabled()) return "/directory"
    return "/home";
  }




  return (
    <Route
      path
      exact={rest.exact}
      render={(props) =>
        isModuleEnabled ? (
          page
        ) : (
          <Redirect to={handleRedirect()} />
        )
      }
    />
  );
};

export default EnabledMemberRoute;
